import serviceApi from 'services/api';
import auth from 'services/auth';

const api = process.env.REACT_APP_ENVIRONMENT === 'local' ? auth : serviceApi;

interface LatchDoors {
  uuid: string;
  name: string;
  type: string;
  buildingUuid: string;
}

interface Address {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  city: string;
  country: string;
  postalCode: string;
  state: string;
}

interface LatchBuildings {
  uuid: string;
  name: string;
  address: Address;
}

/* The LatchDoorProps type represents the properties of a Latch Door. */
export type LatchDoorProps = {
  doors: LatchDoors[];
};

/* The LatchBuildingProps type represents the properties of a Latch Building. */
export type LatchBuildingProps = {
  buildings: LatchBuildings[];
};

/* The LatchBuildingRequest type represents the request properties required to fetch Latch Buildings. */
export type LatchBuildingRequest = {
  clientId?: string;
  clientSecret?: string;
  keyType?: string;
};

/* The function retrieves a list of Doors by making a POST request to the `/apiv1/admin/retrieve/doors/${uuid}` endpoint. */
const retrieveDoors = async (uuid: string | undefined) => {
  const response = await api.post<LatchDoorProps>(`/apiv1/admin/retrieve/doors/${uuid}`);
  return response?.data;
};

/* The function retrieves a list of latch buildings by making a POST request to the `/apiv1/admin/retrieve/buildings` endpoint. */
const retrieveLatchBuildings = async (request: LatchBuildingRequest) => {
  const response = await api.post<LatchBuildingProps>(`/apiv1/admin/retrieve/buildings`, request);
  return response?.data;
};

const LatchService = {
  retrieveDoors,
  retrieveLatchBuildings
};

export default LatchService;
